// Access Control Configuration
export const accessControlConfig = {
  // Toggle this feature on/off
  enabled: true,
  
  // Array of email addresses allowed to login
  allowedEmails: [
    "crm@brikitt.com",
    "itisha@brikitt.com",
    "finance@brikitt.com",
    // Add more emails as needed
  ]
};
